import { faBinoculars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import Tooltip from '@/ui/components/Tooltip';

interface Props {
  requestedAt?: string | null;
  source?: string | null;
}

const DiscoveryBadge = ({ requestedAt, source }: Props) => {
  const formattedDate = requestedAt
    ? new Date(requestedAt).toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    : null;

  const tooltipContent = (
    <div className="text-sm">
      {formattedDate && (
        <div>
          {formattedDate} via {source || 'Unknown'}
        </div>
      )}
    </div>
  );

  return (
    <Tooltip tooltipContent={tooltipContent}>
      <span className="flex items-center">
        <FontAwesomeIcon icon={faBinoculars} className="mr-2" />
        Discovered
      </span>
    </Tooltip>
  );
};

export default React.memo(DiscoveryBadge);
